var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerWidth && _vm.innerHeight)?_c('div',{staticClass:"page-wrapper",style:({ width: (_vm.innerWidth + "px"), height: (_vm.innerHeight + "px") })},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }